import { useQuery, useQueryClient } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { ProfilePage } from '@/features/auth/ProfilePage';
import { meQueryOptions } from '@/features/auth/session';

/** Профиль текущего сотрудника — открыт любой роли: сотрудника дал `_app`. */
export const Route = createFileRoute('/_app/profile')({
  component: ProfileRoute,
});

function ProfileRoute() {
  const { member: loaded } = Route.useRouteContext();
  const queryClient = useQueryClient();
  // Как и в оболочке: карточка из кэша `/me`, чтобы профиль не расходился с сайдбаром.
  const { data: member = loaded } = useQuery(meQueryOptions);

  return (
    <ProfilePage
      member={member}
      // На вход уводит оболочка: она следит за `/me` и знает, куда вернуть после входа.
      // Здесь достаточно перепроверить сессию, а не дублировать переход.
      onSessionExpired={() => void queryClient.invalidateQueries({ queryKey: meQueryOptions.queryKey })}
    />
  );
}
